import { createSlice } from '@reduxjs/toolkit';
import { SysAppDto } from '../../services/api/sysAppService';
import {
  fetchSysApps,
  fetchSysApp,
  createSysApp,
  updateSysApp,
  deleteSysApp,
  setSysAppActive,
} from '../thunks/sysAppThunks';

export interface SysAppState {
  apps: SysAppDto[];
  selectedApp: SysAppDto | null;
  totalCount: number;
  page: number;
  pageSize: number;
  isLoading: boolean;
  error: string | null;
}

const initialState: SysAppState = {
  apps: [],
  selectedApp: null,
  totalCount: 0,
  page: 1,
  pageSize: 20,
  isLoading: false,
  error: null,
};

const sysAppSlice = createSlice({
  name: 'sysApp',
  initialState,
  reducers: {
    clearError: (state) => { state.error = null; },
    clearSelectedApp: (state) => { state.selectedApp = null; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSysApps.pending, (state) => { state.isLoading = true; state.error = null; })
      .addCase(fetchSysApps.fulfilled, (state, action) => {
        state.isLoading = false;
        state.apps = action.payload.apps;
        state.totalCount = action.payload.totalCount;
        state.page = action.payload.page;
        state.pageSize = action.payload.pageSize;
      })
      .addCase(fetchSysApps.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      });

    builder
      .addCase(fetchSysApp.pending, (state) => { state.isLoading = true; state.error = null; })
      .addCase(fetchSysApp.fulfilled, (state, action) => {
        state.isLoading = false;
        state.selectedApp = action.payload;
      })
      .addCase(fetchSysApp.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      });

    builder
      .addCase(createSysApp.pending, (state) => { state.isLoading = true; state.error = null; })
      .addCase(createSysApp.fulfilled, (state) => { state.isLoading = false; })
      .addCase(createSysApp.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      });

    builder
      .addCase(updateSysApp.pending, (state) => { state.isLoading = true; state.error = null; })
      .addCase(updateSysApp.fulfilled, (state) => { state.isLoading = false; })
      .addCase(updateSysApp.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      });

    builder
      .addCase(deleteSysApp.pending, (state) => { state.isLoading = true; state.error = null; })
      .addCase(deleteSysApp.fulfilled, (state) => { state.isLoading = false; })
      .addCase(deleteSysApp.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      });

    builder
      .addCase(setSysAppActive.pending, (state) => { state.isLoading = true; state.error = null; })
      .addCase(setSysAppActive.fulfilled, (state) => { state.isLoading = false; })
      .addCase(setSysAppActive.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      });
  },
});

export const { clearError, clearSelectedApp } = sysAppSlice.actions;
export default sysAppSlice.reducer;
